// Module
var code = "<ldap-security-fieldset\n  values=\"$ctrl.reactValues\"\n  on-change=\"($ctrl.onChangeReactValues)\"\n  upload-state=\"$ctrl.getUploadState()\"\n  title=\"$ctrl.title\"\n  limited-feature-id=\"$ctrl.limitedFeatureId\"\n></ldap-security-fieldset>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/settings/authentication/ldap/ldap-settings-security/ldap-settings-security.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;